import React from "react";
import MathContainer from './MathContainer'
import "./App.css"
import "./Responsive.css"

export default function App() {
  return (
    <div className="App">
      <h1>Math Master</h1>
      <MathContainer />
    </div>
  );
}
